import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";

const JOIN_ALTERNATES = [
  { hreflang: "en", path: "/join" },
  { hreflang: "hi", path: "/hi/join" },
  { hreflang: "x-default", path: "/join" },
];

export default function Join() {
  useSeo({ title: "Get paid to test apps on your phone", description: "Paid 45-minute testing sessions on your own phone or laptop. ₹300 per session plus bonuses for real bugs, paid to UPI. Join 20,000 testers across India.", path: "/join", alternates: JOIN_ALTERNATES });
  const [form, setForm] = useState({ name: "", city: "", email: "" });
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.join(form);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <main className="app-main"><div className="wrap narrow" data-testid="join-confirm">
        <span className="pill">Link sent</span>
        <h1 style={{ marginTop: 12 }}>Check your email.</h1>
        <p className="lede">We've sent an activation link to <b>{form.email}</b>. Open it to confirm your devices and UPI ID, and you'll start receiving session offers.</p>
        <p className="muted small">Didn't get it? Check spam, or <button type="button" className="btn ghost sm" onClick={() => setSent(false)}>try again</button>.</p>
      </div></main>
    );
  }

  return (
    <main className="app-main"><div className="wrap narrow">
      <span className="pill neutral">Get paid to test apps</span>
      <h1 style={{ marginTop: 12 }}>Become a 99tests tester.</h1>
      <p className="lede">Run short, paid testing sessions on your own phone or laptop — ₹300 per 45-minute session plus bonuses for real bugs, paid to your UPI.</p>
      <div className="panel-soft" style={{ padding: "18px 20px", marginTop: 16 }}>
        <h4 style={{ marginBottom: 8 }}>How it works</h4>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7, fontSize: 15 }}>
          <li>We email you when a session matches your device.</li>
          <li>45 or 90 minutes, a fixed fee whether or not you find bugs.</li>
          <li>Bonuses of ₹100–₹500 for each real, reproducible bug.</li>
          <li>Paid to your UPI after the client's report goes out.</li>
        </ul>
      </div>
      <form className="panel-soft" style={{ padding: 26, marginTop: 16 }} onSubmit={submit} data-testid="join-form">
        {error && <p className="err" style={{ color: "var(--fail)", fontWeight: 500 }} data-testid="join-error">{error}</p>}
        <div className="row">
          <div className="field"><label htmlFor="name">Name</label><input id="name" data-testid="join-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="field"><label htmlFor="city">City</label><input id="city" data-testid="join-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></div>
        </div>
        <div className="field"><label htmlFor="email">Email</label><input type="email" id="email" data-testid="join-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /><p className="hint">We'll send a link to confirm your devices and UPI ID.</p></div>
        <button className="btn green block" type="submit" disabled={busy} data-testid="join-submit">{busy ? "Sending…" : "Send me the activation link"}</button>
      </form>
      <p className="muted small" style={{ marginTop: 16 }}>By joining you'll accept the <Link to="/tester-terms">tester terms</Link> when you activate.</p>
      <p className="muted small" style={{ marginTop: 8 }}><Link to="/hi/join" data-testid="lang-hi">हिंदी में पढ़ें</Link></p>
    </div></main>
  );
}
